import React, { useState, useEffect } from 'react';
import { Instagram, MessageCircle } from 'lucide-react';

// TikTok icon component (lucide doesn't have it)
const TikTokIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SocialLinks = ({ className = "", iconSize = "w-5 h-5" }) => {
  const [socialMedia, setSocialMedia] = useState({
    instagram: 'https://www.instagram.com/cimmodua/',
    telegram: 'https://t.me/cimmodua',
    tiktok: 'https://www.tiktok.com/@cimm.od.ua'
  });

  useEffect(() => {
    // Fetch social links from API
    fetch(`${API_URL}/api/social-links`)
      .then(res => res.json())
      .then(data => {
        if (data) {
          setSocialMedia(data);
        }
      })
      .catch(err => console.error('Error loading social links:', err));
  }, []);

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {socialMedia.instagram && (
        <a
          href={socialMedia.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg bg-orange-500/10 hover:bg-orange-500/20 text-orange-500 border border-orange-500/20 hover:border-orange-500/40 transition-all duration-300 hover:scale-110"
          aria-label="Instagram"
        >
          <Instagram className={iconSize} />
        </a>
      )}
      
      {socialMedia.telegram && (
        <a
          href={socialMedia.telegram}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg bg-orange-500/10 hover:bg-orange-500/20 text-orange-500 border border-orange-500/20 hover:border-orange-500/40 transition-all duration-300 hover:scale-110"
          aria-label="Telegram"
        >
          <MessageCircle className={iconSize} />
        </a>
      )}
      
      {socialMedia.tiktok && (
        <a
          href={socialMedia.tiktok}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg bg-orange-500/10 hover:bg-orange-500/20 text-orange-500 border border-orange-500/20 hover:border-orange-500/40 transition-all duration-300 hover:scale-110"
          aria-label="TikTok"
        >
          <TikTokIcon className={iconSize} />
        </a>
      )}
    </div>
  );
};

export default SocialLinks;
